import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/cloud-cog.vue
var o = {
	name: "DtIconCloudCog",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--cloud-cog"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Cloud Cog",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M4.179 1.007A4 4 0 0 1 8.205 3.5h.552a2.75 2.75 0 0 1 1.527 5.011.5.5 0 1 1-.569-.822A1.75 1.75 0 0 0 8.746 4.5H7.85a.5.5 0 0 1-.48-.358A3 3 0 1 0 2.357 7.1a.5.5 0 1 1-.712.702A4 4 0 0 1 4.18 1.008Z",
		fill: "currentColor"
	}, null, -1), r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M6 6a.5.5 0 0 1 .5.5v.063c.184.047.357.12.516.214l.13-.13a.5.5 0 1 1 .708.707l-.13.13c.093.16.166.332.213.516H8a.5.5 0 0 1 0 1h-.063c-.047.184-.12.357-.214.516l.13.13a.5.5 0 0 1-.707.708l-.13-.13a2.02 2.02 0 0 1-.516.213v.063a.5.5 0 1 1-1 0v-.063a1.988 1.988 0 0 1-.516-.214l-.13.13a.5.5 0 0 1-.708-.707l.13-.13A1.988 1.988 0 0 1 4.064 9H4a.5.5 0 0 1 0-1h.063c.047-.184.12-.357.214-.516l-.02-.02-.11-.11a.5.5 0 0 1 .707-.708l.13.13a2.02 2.02 0 0 1 .516-.213V6.5A.5.5 0 0 1 6 6ZM5 8.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=cloud-cog.js.map